<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/statistics/order/list'

export default {
  name: "order",
  mixins: [curdMixins],
  components: { list },
  methods: {
    
  }
};
</script>